// extracted by mini-css-extract-plugin
module.exports = {"thankyouHeader":"returnConfirmation_thankyouHeader__oaBhP","thankyouReturnitems":"returnConfirmation_thankyouReturnitems__gVJVx"};